export async function fetchWhoisData(domain: string) {
  const apiKey = "at_VO0F5kLxzgUqCx8pjQhnqBZJvxyog";
  const url = `https://www.whoisxmlapi.com/whoisserver/WhoisService?apiKey=${apiKey}&domainName=${encodeURIComponent(domain)}&outputFormat=JSON`;
  const response = await fetch(url);
  if (!response.ok) {
    throw new Error("Failed to fetch WHOIS data");
  }
  return response.json();
} 